var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnglish = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12 21.167a9.167 9.167 0 1 0 0-18.334 9.167 9.167 0 0 0 0 18.334"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8.333 3.75h.917a26.06 26.06 0 0 0 0 16.5h-.917M14.75 3.75a26.06 26.06 0 0 1 0 16.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M3.75 15.667v-.917a26.06 26.06 0 0 0 16.5 0v.917M3.75 9.25a26.06 26.06 0 0 1 16.5 0"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 1.5,
  fill: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 21.5,
  r: 1.5,
  fill: "currentColor"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.5,
  cy: 2.5,
  r: 1.5,
  fill: "currentColor"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.5,
  cy: 21.5,
  r: 1.5,
  fill: "currentColor"
})));
export default SvgEnglish;